if (!customElements.get('featured-products-images')) {
  customElements.define(
    'featured-products-images',
    class FeaturedProductsImages extends HTMLElement {
      constructor() {
        super();
      }

      handleChange() {
        if (this.toggle.checked) {
          this.image2.style.opacity = "100";
        } else {
          this.image2.style.opacity = "0";
        }
      }

      connectedCallback() {
        this.image2 = this.querySelector('img.image_2');
        this.toggle = this.querySelector("input[name='toggle']");
        
        this.toggle.addEventListener('change', this.handleChange.bind(this));
      }

      disconnectedCallback() {
        this.toggle.removeEventListener('change', this.handleChange.bind(this));
      }
    }
  );
}